export default __webpack_public_path__ + "static/media/Science.fdc25dd4.jpg";